/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getAuth } from "firebase/auth";
import VisitShareButton from "./../../sidebar/VisitShareButton";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import freeCountries from "../../../utils/freeCountries.json";

const AvatarMenue1 = ({ showSideBarMobile, setShowSideBarMobile }) => {
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const orders = useSelector((state) => state.OrdersReducer);
  const [data, setData] = useState("");
  const [data2, setData2] = useState("");
  const location = useLocation();
  const { t } = useTranslation();
  const dir = i18n.dir();
  const isFreeCountry = freeCountries.includes(account?.country);
  const currentLang = i18n.language;
  const [showDhdTimerState, setShowDhdTimerState] = useState(true);
  const showDhdTimer = showDhdTimerState;

  const isRtl = dir === "rtl";

  useEffect(() => {
    setData(account);
    setData2(store);
  }, [account, store]);

  const storeName = account?.store?.split(".")[0];
  const domain = `${storeName}.foorweb.online`;
  const digitalStore = useSelector((state) => state.digitalStoreReducer);

  const getLogoSrc = () => {
    const productMode = account.productMode ?? "classic";

    if (productMode === "classic") {
      return data2?.logo || "https://4oey1j8tyx.ufs.sh/f/rbKe0tEW4UNk3sJTTVkx1I8VlUWNceyu9XYaJZTiR2sdjD5S";
    } else if (productMode === "product") {
      return data2?.img || "https://4oey1j8tyx.ufs.sh/f/rbKe0tEW4UNk3sJTTVkx1I8VlUWNceyu9XYaJZTiR2sdjD5S"; // هنا كتخدم data2?.img
    } else {
      return digitalStore?.logo || "https://4oey1j8tyx.ufs.sh/f/rbKe0tEW4UNk3sJTTVkx1I8VlUWNceyu9XYaJZTiR2sdjD5S";
    }
  };

  const planKeyMap = {
    الأساسية: "basic",
    الاساسية: "basic",
    basic: "basic",

    المتطورة: "advanced",
    advanced: "advanced",

    الأسطورية: "legendary",
    الاسطورية: "legendary",
    legendary: "legendary",
  };
  const planKey = planKeyMap[account?.subscription?.plan];

  return (
    <div className={`${showSideBarMobile ? "block" : "hidden"} md:hidden`}>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-30"
        onClick={() => setShowSideBarMobile(!showSideBarMobile)}
      ></div>

      <aside
        id="mobile-sidebar"
        className={`fixed top-0 z-40 h-screen flex flex-col bg-white w-[280px] shadow-xl ${
          dir === "rtl" ? "right-0" : "left-0"
        }`}
        aria-label={t("ui.sidebar")}
      >
        <div className="flex-1 overflow-y-auto bg-[#5a2b73] px-0 pb-4 pt-1 sidebarScroll">
          {/* Header */}
          <div className="top-0 right-0 bg-[#5a2b73] pb-3 pr-2 flex">
            <a href="https://foorweb.net/" className="flex items-center">
              <img
                src={
                  currentLang === "ar" ? "/LogoVersionAr.png" : "/logo-new.png" // نفس اللوغو للفرنسية والانجليزية
                }
                className="h-16 sm:h-16"
                alt="Foorweb"
              />
            </a>
          </div>

          <button
            className={`absolute text-[#825ba0] top-7 ${
              dir === "rtl" ? "left-10" : "right-10"
            }`}
            onClick={() => setShowSideBarMobile(!showSideBarMobile)}
          >
            <i className="bi bi-dash-square-dotted text-2xl"></i>
          </button>

          {/* Profile Section */}
          <div className="p-0 d-flex gap-3 p-sm-2 mr-3">
            <div className="d-flex justify-content-center rounded relative">
              <a
                href="/profile.svg"
                className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-[7px] bg-[#f9c02e] rounded-xl px-2 py-1 text-xs"
              >
                {isFreeCountry
                  ? t("navbar.avatarMenu.free")
                  : planKey
                    ? t(`subscription.plans.${planKey}`)
                    : account?.subscription?.plan}
              </a>
              <img
                src={getLogoSrc()}
                width={65}
                height={65}
                alt={t("ui.profile")}
                className="rounded-[33%] border-2 border-[#f9c02e] border-dashed bg-white"
              />
            </div>

            <div className="d-flex flex-column align-items-center text-white">
              <p className="my-2 text-xl">{data.name}</p>
              <VisitShareButton
                link={
                  account.productMode !== "digital" ? account?.store : domain
                }
                isRTL={isRtl}
              />
            </div>
          </div>

          {/* Navigation */}
          <ul className="space-y-1 mt-[30px]  font-medium custom-scrollbar">
            <li
              className={`  transition ${
                location && location.pathname === "/dashborad"
                  ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                  : "bg-[#5a2b73] dark:!bg-[#19171A]"
              }`}
            >
              <Link
                to={"/dashboard"}
                className={`flex items-center p-2  h-[51px] ${
                  location && location.pathname === "/dashborad"
                    ? "hover:bg-[#52276a] "
                    : "hover:bg-[#52276a] "
                } group`}
              >
                <div
                  className={`  ${
                    location && location.pathname === "/dashborad"
                      ? "text-[#dcb5f3] "
                      : "text-[#fff]"
                  } `}
                >
                  <i className="bi bi-speedometer2 mx-sm-3 mx-0 my-auto fs-5" />
                  <span className="">{t("sidebar.dashboard")}</span>
                </div>
              </Link>
            </li>

            {showDhdTimer && false && (
              <li
                className={`transition relative overflow-hidden group ${
                  location && location.pathname === "/special-offer"
                    ? "bg-[#522868] hover:bg-[#522868]"
                    : "bg-gradient-to-r from-[#5a2b73] to-[#6a3b83] dark:!bg-[#19171A]"
                } hover:shadow-xl`}
              >
                {/* Effet de particules scintillantes en arrière-plan */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700">
                  <div
                    className="absolute top-0 left-1/4 w-1 h-1 bg-yellow-300 rounded-full animate-ping"
                    style={{ animationDelay: "0.2s" }}
                  ></div>
                  <div
                    className="absolute top-1/3 right-1/4 w-1.5 h-1.5 bg-amber-400 rounded-full animate-ping"
                    style={{ animationDelay: "0.5s" }}
                  ></div>
                  <div
                    className="absolute bottom-1/4 left-1/3 w-1 h-1 bg-orange-300 rounded-full animate-ping"
                    style={{ animationDelay: "0.8s" }}
                  ></div>
                </div>

                <Link
                  // to={"/special-offer"}
                  className={`relative flex items-center p-2 h-[51px] group transition-all duration-300 ${
                    location && location.pathname === "/special-offer"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                  }`}
                >
                  <div className="flex items-center gap-3 w-full">
                    <span
                      className="inline-flex items-center justify-center w-8 h-8 rounded-full animate-pulse group-hover:animate-bounce"
                      style={{
                        background:
                          "linear-gradient(135deg, #FFD700, #FFA500, #FF8C00)",
                        boxShadow: "0 0 20px rgba(255, 215, 0, 0.6)",
                        color: "#2b1200",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <span className="transform group-hover:scale-110 transition-transform duration-300">
                        ✨
                      </span>
                    </span>

                    {/* Texte avec effet de brillance */}
                    <span className="text-white font-semibold tracking-wide relative">
                      {t("sidebar.specialOffer")}
                      <span className="absolute -inset-1 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 group-hover:animate-shimmer"></span>
                    </span>

                    {/* Badge NEW amélioré */}
                    <span
                      className="ml-auto text-[10px] px-2 py-1 rounded-full font-bold relative overflow-hidden"
                      style={{
                        background: "linear-gradient(135deg, #FFD700, #FFA500)",
                        color: "#2b1200",
                        border: "1px solid rgba(255, 215, 0, 0.5)",
                        boxShadow: "0 2px 10px rgba(255, 215, 0, 0.4)",
                      }}
                    >
                      <span className="relative z-10">{t("sidebar.soon")}</span>
                      <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -skew-x-12 animate-shimmer"></span>
                    </span>
                  </div>
                </Link>
              </li>
            )}

            {(account.productMode ?? "classic") === "classic" && (
              <li
                className={`  transition ${
                  location && location.pathname === "/orders"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                }`}
              >
                <Link
                  to={"/orders"}
                  className={`flex items-center p-2  h-[51px] text-white d-flex justify-content-between ${
                    location && location.pathname === "/orders"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                  } group`}
                >
                  <div
                    className={`${
                      location && location.pathname === "/try"
                        ? "text-[#dcb5f3] "
                        : "text-[#fff]"
                    } `}
                  >
                    <i className="bi bi-cart3 mx-sm-3 mx-0  fs-5 i-nav-link my-auto"></i>
                    <span className="">{t("sidebar.orders")}</span>
                  </div>
                  {orders.filter((order) => order.deleveryStatus === "1")
                    .length > 0 && (
                    <span className="inline-flex items-center justify-center px-2 ms-3 text-sm font-medium text-[#5a2b73] bg-[#be97d4] rounded-full pt-1">
                      {
                        orders.filter((order) => order.deleveryStatus === "1")
                          .length
                      }
                    </span>
                  )}
                </Link>
              </li>
            )}
            {digitalStore?.isActiveDigitalProducts &&
              (account.productMode ?? "classic") !== "classic" && (
                <li
                  className={`transition ${
                    location?.pathname === "/orders/digital"
                      ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                      : "bg-[#5a2b73] dark:!bg-[#19171A]"
                  }`}
                >
                  <Link
                    to="/orders/digital"
                    className={`flex items-center p-2 h-[51px] text-white justify-between ${
                      location?.pathname === "/orders/digital"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`${
                        location?.pathname === "/orders/digital"
                          ? "text-[#dcb5f3]"
                          : "text-[#fff]"
                      }`}
                    >
                      <i className="bi bi-cart3 mx-sm-3 mx-0 fs-5 i-nav-link my-auto"></i>
                      <span className="">{t("sidebar.digitalOrders")}</span>
                    </div>
                  </Link>
                </li>
              )}

            {(account.productMode ?? "classic") === "classic" && (
              <li
                className={`  transition ${
                  location && location.pathname === "/Ordersabndn"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                }`}
              >
                <Link
                  to={"/Ordersabndn"}
                  className={`flex items-center p-2  h-[51px] text-white d-flex justify-content-between ${
                    location && location.pathname === "/Ordersabndn"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                  } group`}
                >
                  <div
                    className={`  ${
                      location && location.pathname === "/Ordersabndn"
                        ? "text-[#dcb5f3] "
                        : "text-[#fff]"
                    } `}
                  >
                    <i className="bi bi-cart-x-fill mx-sm-3 mx-0 fs-5 i-nav-link my-auto"></i>
                    <span className="">{t("sidebar.abndndOrders")}</span>
                  </div>
                  {orders.filter((order) => order.deleveryStatus === "20")
                    .length > 0 && (
                    <span className="inline-flex items-center justify-center px-2 ms-3 text-sm font-medium text-[#5a2b73] bg-[#be97d4] rounded-full pt-1">
                      {
                        orders.filter((order) => order.deleveryStatus === "20")
                          .length
                      }
                    </span>
                  )}
                </Link>
              </li>
            )}

            <li
              className={`  transition ${
                location && location.pathname === "/products"
                  ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                  : "bg-[#5a2b73] dark:!bg-[#19171A]"
              }`}
            >
              <Link to={"/products"}>
                <a
                  className={`flex items-center p-2  h-[51px] text-white d-flex justify-content-between ${
                    location && location.pathname === "/products"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                  } group`}
                >
                  <div
                    className={`  ${
                      location && location.pathname === "/products"
                        ? "text-[#dcb5f3] "
                        : "text-[#fff]"
                    } `}
                  >
                    <i className="bi bi-box-seam mx-sm-3 mx-0 fs-5 my-auto" />
                    <span className="flex-1  whitespace-nowrap">
                      {t("sidebar.products")}
                    </span>
                  </div>
                </a>
              </Link>
            </li>

            {(account.productMode ?? "classic") === "classic" && (
              <li
                className={`transition ${
                  location && location.pathname === "/settings/store"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                }`}
              >
                <Link to={`/settings/store`}>
                  <a
                    className={`flex items-center p-2  h-[51px] text-white ${
                      location && location.pathname === "/settings/store"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`  ${
                        location && location.pathname === "/settings/store"
                          ? "text-[#dcb5f3] "
                          : "text-[#fff]"
                      } `}
                    >
                      <i className="bi bi-palette mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1  whitespace-nowrap">
                        {t("sidebar.storeCostumisation")}
                      </span>
                    </div>
                  </a>
                </Link>
              </li>
            )}
            {(account.productMode ?? "classic") === "digital" && (
              <li
                className={`transition ${
                  location && location.pathname === "/digital/settings/store"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                }`}
              >
                <Link to={`/digital/settings/store`}>
                  <a
                    className={`flex items-center p-2  h-[51px] text-white ${
                      location &&
                      location.pathname === "/digital/settings/store"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`  ${
                        location &&
                        location.pathname === "/digital/settings/store"
                          ? "text-[#dcb5f3] "
                          : "text-[#fff]"
                      } `}
                    >
                      <i className="bi bi-palette mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1  whitespace-nowrap">
                        {t("sidebar.storeCostumisation")}
                      </span>
                    </div>
                  </a>
                </Link>
              </li>
            )}

            {/* ---------------------------foorchat--------------------------------------------- */}
            {/* <li
              className={`transition relative ${
                location && location.pathname === "/Foorchat"
                  ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                  : "bg-[#5a2b73] dark:!bg-[#19171A]"
              }`}
            >
              <div className="absolute top-4 left-2 z-10">
                <span className="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-gradient-to-r from-red-500 to-pink-500 rounded-full shadow-lg animate-pulse">
                  جديد
                </span>
              </div>

              <Link to={`/Foorchat`}>
                <a
                  className={`flex items-center p-2 h-[51px] text-white ${
                    location && location.pathname === "/Foorchat"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                  } group`}
                >
                  <div
                    className={`${
                      location && location.pathname === "/Foorchat"
                        ? "text-[#dcb5f3]"
                        : "text-[#fff]"
                    }`}
                  >
                    <i className="bi bi-robot mx-sm-3 mx-0 fs-5 my-auto" />
                    <span className="flex-1 whitespace-nowrap">
                      {t("sidebar.foorchatai")}
                    </span>
                  </div>
                </a>
              </Link>
            </li> */}
            {/* ------------------------------------------------------------------------ */}
            {(account.productMode ?? "classic") === "classic" && (
              <li
                className={`  transition ${
                  location && location.pathname === "/settings/stock"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                }`}
              >
                <Link to={`/settings/stock`}>
                  <a
                    className={`flex items-center p-2  h-[51px] text-white ${
                      location && location.pathname === "/settings/stock"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`  ${
                        location && location.pathname === "/settings/stock"
                          ? "text-[#dcb5f3] "
                          : "text-[#fff]"
                      } `}
                    >
                      <i className="bi bi-collection mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1  whitespace-nowrap">
                        {t("sidebar.stock")}
                      </span>
                    </div>
                  </a>
                </Link>
              </li>
            )}
            {/* {(account.productMode ?? "classic") === "classic" && (
                        <li
                          className={`  transition ${
                            location && location.pathname === "/adduser"
                              ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                              : "bg-[#5a2b73] dark:!bg-[#19171A]"
                          }`}
                        >
                          <Link to={`/adduser`}>
                            <a
                              className={`flex items-center p-2  h-[51px] text-white ${
                                location && location.pathname === "/adduser"
                                  ? "hover:bg-[#52276a]"
                                  : "hover:bg-[#52276a]"
                              } group`}
                            >
                              <div
                                className={`  ${
                                  location && location.pathname === "/adduser"
                                    ? "text-[#dcb5f3] "
                                    : "text-[#fff]"
                                } `}
                              >
                                <i className="bi bi-people mx-sm-3 mx-0 fs-5 my-auto" />
                                <span className="flex-1  whitespace-nowrap">
                                  {t("sidebar.confimatrices")}
                                </span>
                              </div>
                            </a>
                          </Link>
                        </li>
                      )} */}
            {(account.productMode ?? "classic") === "classic" && false && (
              <li
                className={`  transition ${
                  location && location.pathname === "/workers-management"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                }`}
              >
                <Link to={`/workers-management`}>
                  <a
                    className={`flex items-center p-2  h-[51px] text-white ${
                      location && location.pathname === "/workers-management"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`  ${
                        location && location.pathname === "/workers-management"
                          ? "text-[#dcb5f3] "
                          : "text-[#fff]"
                      } `}
                    >
                      <i className="bi bi-people mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1  whitespace-nowrap">
                        {t("sidebar.workersManagement")}
                      </span>
                    </div>
                  </a>
                </Link>
              </li>
            )}

            {(account.productMode ?? "classic") !== "classic" && (
              <li
                className={`transition ${
                  location && location.pathname === "/payment-methods"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                }`}
              >
                <Link to={`/payment-methods`}>
                  <a
                    className={`flex items-center p-2 h-[51px] text-white ${
                      location && location.pathname === "/payment-methods"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`${
                        location && location.pathname === "/payment-methods"
                          ? "text-[#dcb5f3]"
                          : "text-[#fff]"
                      }`}
                    >
                      <i className="bi bi-credit-card mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1 whitespace-nowrap">
                        {t("sidebar.paimentMethods")}
                      </span>
                    </div>
                  </a>
                </Link>
              </li>
            )}

            {(account.productMode ?? "classic") !== "classic" && (
              <li
                className={`transition ${
                  location && location.pathname === "/digital-sections"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                }`}
              >
                <Link to={`/digital-sections`}>
                  <a
                    className={`flex items-center p-2 h-[51px] text-white ${
                      location && location.pathname === "/digital-sections"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`${
                        location && location.pathname === "/digital-sections"
                          ? "text-[#dcb5f3]"
                          : "text-[#fff]"
                      }`}
                    >
                      <i className="bi bi-folder-fill mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1 whitespace-nowrap">
                        {t("sidebar.digitalSections")}
                      </span>
                    </div>
                  </a>
                </Link>
              </li>
            )}

            {/* {(account.productMode ?? "classic") === "classic" && (
              <li
                className={`  transition ${
                  location && location.pathname === "/foorcall"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                }`}
              >
                <Link
                  to={`/foorcall`}
                  className={`flex items-center p-2  h-[51px] text-white ${
                    location && location.pathname === "/foorcall"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                  } group`}
                >
                  <div
                    className={`flex items-center gap-2 ${
                      location && location.pathname === "/foorcall"
                        ? "text-[#dcb5f3] "
                        : "text-[#fff]"
                    } `}
                  >
                    <i className="bi bi-headset mx-sm-3 mx-0 fs-5 my-auto" />
                    <span className="flex-1 whitespace-nowrap">
                      {t("sidebar.foorcall")}
                    </span>
                    <span className="ml-1 px-1.5 py-0.5 text-[10px] font-bold uppercase rounded-full bg-[#dcb5f3] text-[#522868] leading-none">
                      {t("sidebar.new") || "New"}
                    </span>
                  </div>
                </Link>
              </li>
            )} */}

            {(account.productMode ?? "classic") === "classic" && (
              <li
                className={`  transition ${
                  location && location.pathname === "/ship"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                }`}
              >
                <Link to={`/ship`}>
                  <a
                    className={`flex items-center p-2  h-[51px] text-white ${
                      location && location.pathname === "/ship"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`  ${
                        location && location.pathname === "/ship"
                          ? "text-[#dcb5f3] "
                          : "text-[#fff]"
                      } `}
                    >
                      <i className="bi bi-truck mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1  whitespace-nowrap">
                        {t("sidebar.foorship")}
                      </span>
                    </div>
                  </a>
                </Link>
              </li>
            )}

            {(account.productMode ?? "classic") === "classic" && (
              <li
                className={`  transition ${
                  location && location.pathname === "/statistics"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                }`}
              >
                <Link to={`/statistics`}>
                  <a
                    className={`flex items-center p-2  h-[51px] text-white ${
                      location && location.pathname === "/statistics"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`  ${
                        location && location.pathname === "/statistics"
                          ? "text-[#dcb5f3] "
                          : "text-[#fff]"
                      } `}
                    >
                      <i className="fi bi-clipboard-data mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1  whitespace-nowrap">
                        {t("sidebar.statistics")}
                      </span>
                    </div>
                  </a>
                </Link>
              </li>
            )}

            {(account.productMode ?? "classic") === "classic" && (
              <li
                className={` transition ${
                  location && location.pathname === "/landing-page"
                    ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                    : "bg-[#5a2b73] dark:!bg-[#19171A]"
                }`}
              >
                <Link to={`/landing-page`}>
                  <a
                    className={`flex items-center p-2  h-[51px] text-white ${
                      location && location.pathname === "/landing-page"
                        ? "hover:bg-[#52276a]"
                        : "hover:bg-[#52276a]"
                    } group`}
                  >
                    <div
                      className={`  ${
                        location && location.pathname === "/landing-page"
                          ? "text-[#dcb5f3] "
                          : "text-[#fff]"
                      } `}
                    >
                      <i className="bi bi-file-earmark-arrow-down mx-sm-3 mx-0 fs-5 my-auto" />
                      <span className="flex-1  whitespace-nowrap">
                        {t("sidebar.landingPage")}
                      </span>
                    </div>
                  </a>
                </Link>
              </li>
            )}

            {(account.productMode ?? "classic") === "classic" &&
              store.crossSell && (
                <li
                  className={` transition ${
                    location && location.pathname === "/crossSell"
                      ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                      : "bg-[#5a2b73] dark:!bg-[#19171A]"
                  }`}
                >
                  <Link to={`/crossSell`}>
                    <a
                      className={`flex items-center p-2  h-[51px] text-white ${
                        location && location.pathname === "/crossSell"
                          ? "hover:bg-[#52276a]"
                          : "hover:bg-[#52276a]"
                      } group`}
                    >
                      <div
                        className={`  ${
                          location && location.pathname === "/crossSell"
                            ? "text-[#dcb5f3] "
                            : "text-[#fff]"
                        } `}
                      >
                        <i className="bi bi-crosshair mx-sm-3 mx-0 fs-5 my-auto" />
                        <span className="flex-1  whitespace-nowrap">
                          {t("sidebar.crossSell")}
                        </span>
                      </div>
                    </a>
                  </Link>
                </li>
              )}

            {(account.productMode ?? "classic") === "classic" &&
              store.cashBack && (
                <li
                  className={` transition ${
                    location && location.pathname === "/cashBack"
                      ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                      : "bg-[#5a2b73] dark:!bg-[#19171A]"
                  }`}
                >
                  <Link to={`/cashBack`}>
                    <a
                      className={`flex items-center p-2  h-[51px] text-white ${
                        location && location.pathname === "/cashBack"
                          ? "hover:bg-[#52276a]"
                          : "hover:bg-[#52276a]"
                      } group`}
                    >
                      <div
                        className={`  ${
                          location && location.pathname === "/cashBack"
                            ? "text-[#dcb5f3] "
                            : "text-[#fff]"
                        } `}
                      >
                        <i className="bi bi-cash-coin mx-sm-3 mx-0 fs-5 my-auto" />
                        <span className="flex-1  whitespace-nowrap">
                          {t("servicePageDetails.cashBack.highlight")}
                        </span>
                      </div>
                    </a>
                  </Link>
                </li>
              )}

            <li
              className={`  transition ${
                location && location.pathname === "/settings"
                  ? "bg-[#522868] hover:bg-[#522868] text-[#825ba0] font-bold"
                  : "bg-[#5a2b73] dark:!bg-[#19171A]"
              }`}
            >
              <Link to={`/settings`}>
                <a
                  className={`flex items-center p-2  h-[51px] text-white ${
                    location && location.pathname === "/settings"
                      ? "hover:bg-[#52276a]"
                      : "hover:bg-[#52276a]"
                  } group`}
                >
                  <div
                    className={`  ${
                      location && location.pathname === "/settings"
                        ? "text-[#dcb5f3] "
                        : "text-[#fff]"
                    } `}
                  >
                    <i className="bi bi-gear2 mx-sm-3 mx-0 fs-5 my-auto" />
                    <span className="flex-1  whitespace-nowrap">
                      {t("sidebar.parametres")}
                    </span>
                  </div>
                </a>
              </Link>
            </li>
          </ul>
          <div className="px-4 pt-6 pb-2 border-t border-[#6d3a88]">
            <h4 className="text-white text-sm font-medium mb-3 text-center">
              {t("sidebar.doxnload")}
            </h4>
            <div className="flex justify-center space-x-3">
              <a
                href="https://play.google.com/store/apps/details?id=com.foorweb.foorwebapp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/googlePlay.png"
                  alt={t("AccountSettings.twoFA.steps.downloadApp.buttons.googlePlay")}
                  className="h-10"
                />
              </a>
              <a
                href="https://apps.apple.com/us/app/foorweb/id6738890253"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/appStore.png"
                  alt={t("AccountSettings.twoFA.steps.downloadApp.buttons.appStore")}
                  className="h-10"
                />
              </a>
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
};

export default AvatarMenue1;
